import React, { Component } from 'react';
import { Button, DatePicker, Form, Icon, Input } from 'antd'
import _ from 'lodash'
import moment from 'moment'

import './RemarksForm.scss'

export default class RemarksForm extends Component {
    renderContentRow(remarkIdx, rowList) {
        const {
            status,
            isDocumentSent,
            isDocumentVoided,
            onRemarkContentChange,
            onRemarkContentDateChange,
            onRemarkContentRemove
        } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent || isDocumentVoided

        return _.map(rowList, (row, contentIdx) => {
            const { content, date } = row
            return (
                <tr key={contentIdx}>
                    <td>{contentIdx + 1}</td>
                    <td>
                        { isLocked ? content :
                            <Input
                                value={content}
                                onChange={onRemarkContentChange.bind(this, remarkIdx, contentIdx, 'content')}
                            />
                        }
                    </td>
                    <td>
                        {
                            isLocked ? (date ? moment(date).format('YYYY-MM-DD') : 'TBC') :
                            <DatePicker
                                value={date ? moment(date) : undefined}
                                allowClear
                                min={0}
                                onChange={onRemarkContentDateChange.bind(this, remarkIdx, contentIdx, 'date')}
                            />
                        }
                    </td>
                    <td>
                        {
                            !isLocked && (
                                <div className="rm-content-btn" onClick={onRemarkContentRemove.bind(this, remarkIdx, contentIdx)}>
                                    <Icon type="close" />
                                </div>
                            )
                        }
                    </td>
                </tr>
            )
        })
    }

    renderRemark() {
        const {
            status,
            isDocumentSent,
            isDocumentVoided,
            remarks,
            onRemarkChange,
            onRemarkToggle,
            onRemarkRemove,
            onRemarkContentAdd
        } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent || isDocumentVoided

        return _.map(remarks, (remark, remarkIdx) => (
            <div className="remark" key={remarkIdx}>
                <div className="remark-header">
                    <div className="remark-idx">{String.fromCharCode(65 + remarkIdx)}</div>
                    <div className="remark-name">
                        {
                            isLocked  ? remark.name : 
                            <Input value={remark.name} onChange={onRemarkChange.bind(this, remarkIdx, 'name')}/>
                        }
                    </div>
                    <div className="right-control">
                        <div className={`toggle-btn${remark.toggled ? ' toggled' : ''}`} onClick={onRemarkToggle.bind(this, remarkIdx)}>
                            <Icon type="up" />
                        </div>
                        {
                            !isLocked && (
                                <div className="rm-remark-btn" onClick={onRemarkRemove.bind(this, remarkIdx)}>
                                    <Icon type="close" />
                                </div>
                            )
                        }
                    </div>
                </div>
                <table className={`content-table${remark.toggled ? ' toggled' : ''}`}>
                    <thead>
                        <tr>
                            <th width={40}></th>
                            <th>Content</th>
                            <th width={120}>Date</th>
                            <th width={40}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderContentRow(remarkIdx, remark.rows)}
                        { 
                            !isLocked && (   
                                <tr className="add-content">
                                    <td colSpan={4}>
                                        <Button onClick={onRemarkContentAdd.bind(this, remarkIdx)}>
                                            Add Content
                                        </Button>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        ))
    }

    render() {
        const { status, onRemarkAdd, isDocumentSent, isDocumentVoided } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent || isDocumentVoided

        return (
            <Form className="RemarksForm">
                <ol>
                    {this.renderRemark()}
                </ol>
                { !isLocked && (<Button className="add-remark-btn" type="primary" size="large" onClick={onRemarkAdd.bind(this)}>Add Remark</Button>) }
            </Form>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/RemarksForm/RemarksForm.js